import React, { useEffect, useRef, useState, useCallback } from "react";
import HeaderControls from "../components/headerControls";
import FloatingHearts from "./floatingHearts";
import ProductsListing from "./productsListing";
import { TbHeartFilled } from "react-icons/tb";
import { VideoRoom } from "./videoRoom";
import "./style.css";
import useAppAccessor from "../../../hooks/useappAccessor";
import useAppDispatch from "../../../hooks/useAppDispatch";
import { uploadThumbnail } from "../../../services/record.service";
import StreamControls from "./streamControls/streamControls";
import Loader from "../../../components/loader";
import ToastMessage from "../../../components/toastMessage";
import { checkIframeable, callCreateStreamAPI, callCreateTokenAPI, callGetRTMToken, callEvent } from "../../../services/main.service";
import { setCreateStreamData, setTokenData, setRTMToken, setStramState } from "../../live-main/livemain.actions";
import {
  Camera,
  Microphone,
  CAMOFF,
  MICOFF,
  RecordOFF,
  RecordON,
  RecordReady,
  ChatBubble,
  ListControl,
  List,
  ScreenOn,
  ScreenOff,
  Chatnew,
  No_Permission,
  Alert,
  Icon_Wifi_Off,
} from "../../../assets/icons";
import CustomShareBottomSheet from "./customShareBottomSheet";
import BottomSheet from "../../../components/bottomSheet";
import { set } from "lodash";
import ModalBottomChatMobile from "./ModalMobileChat";
import ModalBottomInteractionsMobile from "./ModalMobileInteractions";
import { setIn } from "formik";
import { clear } from "console";
import MicSelector from "../components/micSelector";
import CamSelector from "../components/camSelector";
import CameraPreview from "../components/cameraPreview";
import MessageItem from "../../agora-chat-mobile/components/messenger-chat";

declare global {
  namespace NavigatorPermissions {
    type PermissionName = 'camera' | 'microphone' | 'geolocation' | string;
  }
}

const HostAttendeeView = () => {
  const dispatch = useAppDispatch();
  const [isGoliveStatus, setIsGoliveStatus] = useState(false);
  const { getControls, getRecordData, getUserData, getLiveMainData, getInteractions } =
    useAppAccessor();
    const { interactionData } = getInteractions();
  const { user, client, language } = getUserData();
  const { publicUserData } = user;
  const {
    isRecord,
    roleCopresenter,
    isCameraOn,
    isMicOn,
    checkRecord,
    isScreenSharing,
    screenSharingToast,
    toastMess,
    copresenterNames,
    isMutedByHost,
  } = getControls();
  const { hostSeconds, streamState, slowNetwork, isHostConnected } = getLiveMainData();
  const { recordData } = getRecordData();
  const [hasPermission, setHasPermission] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const videoRef = useRef(null);
  const [isShowLoader, setIsShowLoader] = useState(false);
  const [loaderMessage, setLoaderMessage] = useState("");
  const [userCheck, setUserCheck] = useState(null);
  const [toastMessage, setToastMessage] = useState("");
  const [toastImg, setToastImg] = useState<any>();
  const [isShowToast, setIsShowToast] = useState(false);
  const [toggleRecording, setToggleRecording] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [dnLink, setDnLink] = useState("");
  const [showBottomSheet, setShowBottomSheet] = useState(false);
  const [url, setUrl] = useState("");
  const [modalBottom, setModalBottom] = useState(false);
  const [hasPanel, setHasPanel] = useState(false);
  const [interactionsBottom, setInteractionsBottom] = useState(false);
  const [layout, setLayout] = useState(null);
  const [windowHeight, setWindowHeight] = useState(window.innerHeight);
  const [camSelectorVisible, setCamSelectorVisible] = useState(false);
  const [micSelectorVisible, setMicSelectorVisible] = useState(false);
  const [chatMessages, setChatMessages] = useState<any[]>([]);
  const [chatInputFocused, setChatInputFocused] = useState(false);
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isHost = () => {
    return window.location.href.indexOf("/stream") > -1;
  };
  let interval : NodeJS.Timer;

  const isMobile =
    window.innerWidth < 768 ||
    /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

    const camRef = useRef<HTMLDivElement>(null);
    const [camHeight, setCamHeight] = useState(0);
    const micRef = useRef<HTMLDivElement>(null);
    const [micHeight, setMicHeight] = useState(0);
  
    useEffect(() => {
      setTimeout(() => {
      const camElement = document.getElementById('camSelector');
      if (camElement) {
        setCamHeight(camElement.offsetHeight);
      }
      }, 100);
    }, [camSelectorVisible]);

    useEffect(() => {
      setTimeout(() => {
      const camElement = document.getElementById('micSelector');
      if (camElement) {
        setMicHeight(camElement.offsetHeight);
      }
      }, 100)
    }, [micSelectorVisible]);

  useEffect(() => {
    const scrollToTop = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    scrollToTop();
    
    setTimeout(scrollToTop, 2000);
    setTimeout(scrollToTop, 3000);
    setTimeout(scrollToTop, 4000);
    setTimeout(scrollToTop, 5000);

    const scrollInterval = setInterval(scrollToTop, 1000);

    interval = setInterval(() => {
    navigator.permissions.query({ name: 'camera' as PermissionName })
    .then(permissionStatus => {
      if(permissionStatus.state === 'granted') {
        setHasPermission(true);
        clearInterval(interval);
      } else {
        setHasPermission(false);
      }
    })
    .catch(error => {
      setHasPermission(false);
    });
    }, 1000);

    return () => {
      clearInterval(interval);
      clearInterval(scrollInterval);
    };
  }, []);

  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [isRecord]);

  useEffect(() => {
    setToggleRecording(true);
    const timer = setTimeout(() => {
      setToggleRecording(false);
    }, 2000);

    return () => {
      clearTimeout(timer);
    };
  }, [checkRecord]);

  useEffect(() => {
    if (isHost()) {
      var interval = setInterval(() => {
        var addInteractionMode = document.getElementById('ModalInner') ? true : false;
        if (addInteractionMode) {
          setIsOpen(false);
        }
      }, 500);
    }
    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (hasPanel) {
      setHasPanel(false);
    }
    interactionData.map((p:any) => {
      if (p.attributes.shouldShow) {
        setHasPanel(true);
      }});

  }, [interactionData, slowNetwork]);

  useEffect(() => {
    if (modalBottom === false){
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }
  },[modalBottom]);

  useEffect(() => {
    const preventScroll = (e: TouchEvent) => {
      const target = e.target as HTMLElement;
      const isScrollableElement = target.closest('.overflow-y-auto, .overflow-x-auto, .containerbottomSheet, #iFrameContainer, .listContainer, .chatMessagesContainer, .chatbox--messages');
      
      if (!isScrollableElement) {
        e.preventDefault();
      }
    };

    const preventBodyScroll = () => {
      document.body.style.overflow = 'hidden';
      document.body.style.position = 'fixed';
      document.body.style.width = '100%';
      document.body.style.height = '100%';
      document.documentElement.style.overflow = 'hidden';
      document.documentElement.style.height = '100%';
    };

    const restoreBodyScroll = () => {
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.height = '';
      document.documentElement.style.overflow = '';
      document.documentElement.style.height = '';
    };

    const handleScroll = () => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    };

    preventBodyScroll();
    document.addEventListener('touchmove', preventScroll, { passive: false });
    window.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      restoreBodyScroll();
      document.removeEventListener('touchmove', preventScroll);
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  
  const checkIfAnyoneSharing = () => {
    const fullScreenElement = document.getElementById('fullScreen');
    if (!fullScreenElement) return false;
    
    const videoElement = fullScreenElement.closest('[id^="shsh"]')?.querySelector('video') as HTMLVideoElement | null;
    if (!videoElement) return false;
    
    const srcObject = videoElement.srcObject;
    const videoTrack = srcObject instanceof MediaStream ? srcObject.getVideoTracks()?.[0] : null;
    if (!videoTrack) return false;
    
    const isScreenShare = 
      videoTrack.label?.toLowerCase().includes('screen') ||
      (videoElement.videoWidth === 1280 && videoElement.videoHeight === 720);
    
    return isScreenShare;
  };

  useEffect(() => {
    setIsVisible(false);
    setToggleRecording(false);
    if (!checkIfAnyoneSharing()) {
      return;
    }
    
    if (roleCopresenter || isHost()) {
      var shown = false;
      var interval = setInterval(() => {
        const selfSharing = isScreenSharing;
        const anyoneSharing = checkIfAnyoneSharing();
        const hostSharing = document.getElementById('fullScreenHost') ? true : false;
        
        if (!selfSharing && anyoneSharing) {
          setTimeout(() => {
            if (streamState === "ended" || streamState === "notStarted") {
              return;
            }
            if (checkIfAnyoneSharing() && !shown) {
              setToastMessage(hostSharing ? "Host started screen sharing." : "Co-presenter started screen sharing.");
              setToastImg(null);
              setIsShowToast(true);
              setTimeout(() => {
                setToastMessage("");
                setToastImg(null);
                setIsShowToast(false);
              }, 2000);
              shown = true;
            }
          }, 500);
        }
      }, 1000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [isScreenSharing, streamState, roleCopresenter]);

  useEffect(() => {
    setUserCheck(user);
    //TODO: to be reviewed
  }, [user?.publicUserData?.userId]);

  useEffect(() => {
    // if (!isHost()) {
    //   return;
    // }
    if (streamState === "ended" || streamState === "notStarted") {
      return;
    }
    if (isCameraOn) {
      setToastMessage(language['camera_on']);
      setToastImg(Camera);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    } else {
      setToastMessage(language['camera_off']);
      setToastImg(CAMOFF);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    }
  }, [isCameraOn]);

  useEffect(() => {
    // if (streamState === "ended" || streamState === "notStarted") {
    //   return;
    // }
    var totalTime = publicUserData?.max_meeting_length * 60;
    if (isHost()) {
      var msg = "";
      if (hostSeconds == totalTime - 10 * 60) {
        msg = "You have 10 minutes left in your stream";
        setToastMessage(msg);
        setToastImg(null);
        setIsShowToast(true);
        setTimeout(() => {
          setToastMessage("");
          setToastImg(null);
          setIsShowToast(false);
        }, 3000);
      } else if (hostSeconds == totalTime - 5 * 60) {
        msg = "You have 5 minutes left in your stream";
        setToastMessage(msg);
        setToastImg(null);
        setIsShowToast(true);
        setTimeout(() => {
          setToastMessage("");
          setToastImg(null);
          setIsShowToast(false);
        }, 3000);
      } else if (hostSeconds == totalTime - 1 * 60) {
        msg = "You have 1 minute left in your stream";
        setToastMessage(msg);
        setToastImg(null);
        setIsShowToast(true);
        setTimeout(() => {
          setToastMessage("");
          setToastImg(null);
          setIsShowToast(false);
        }, 3000);
      }
     
    }
  }, [hostSeconds])

  useEffect(() => {
    // if (!isHost()) {
    //   return;
    // }
    if (streamState === "ended" || streamState === "notStarted" || isMutedByHost) {
      return;
    }
    if (isMicOn) {
      setToastMessage(language['microphone_active']);
      setToastImg(Microphone);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    } else {
      setToastMessage(language['microphone_muted']);
      setToastImg(MICOFF);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    }
  }, [isMicOn]);

  useEffect(() => {
    // if (!isHost()) {
    //   return;
    // }
    if (streamState === "ended" || streamState === "notStarted" || streamState === "ending") {
      return;
    }
    if (screenSharingToast) {
      setToastMessage("Screen Share is ON. Camera will remain OFF during screen sharing.");
      setToastImg(ScreenOn);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    } else {
      setToastMessage(language['screen_share']);
      setToastImg(ScreenOff);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    }
  }, [screenSharingToast]);

  useEffect(() => {
    // if (!isHost()) {
    //   return;
    // }
    if (streamState === "ended" || streamState === "notStarted" || streamState === "ending") {
      return;
    }
    if (isScreenSharing) {

    } else {
     // console.log("inner", streamState);
      setToastMessage(language['screen_share']);
      setToastImg(ScreenOff);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 2000);
    }
  }, [isScreenSharing]);

  useEffect(() => {
    handleStartResponse(recordData);
  }, [recordData]);

  function convertDataUrltoBlob(dataUrl: string) {
    const binary = atob(dataUrl.split(",")[1]);
    const array = [];
    for (let i = 0; i < binary.length; i++) {
      array.push(binary.charCodeAt(i));
    }

    return new Blob([new Uint8Array(array)], { type: "image/jpeg" });
  }

  function handleStartResponse(recordData: any) {
    if (recordData?.data?.thumbnailUploadData) {
      setTimeout(() => {
        generateThumbnail(recordData?.data?.thumbnailUploadData);
      }, 5000);
    }
  }

  function generateThumbnail(thumbnailUploadData: any) {
    const video = document.getElementsByTagName("video")[0] as HTMLVideoElement;

    if (video && video.videoWidth && video.videoHeight) {
      const canvas = document.createElement("canvas");

      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;

      const context = canvas.getContext("2d");
      if (context) {
        context?.drawImage(video, 0, 0, canvas.width, canvas.height);
        const imageDataUrl = canvas.toDataURL("image/jpeg");
        const image = convertDataUrltoBlob(imageDataUrl);

        uploadThumbnail(thumbnailUploadData, image);
      }

      canvas.parentElement?.removeChild(canvas);
    }
  }

  const toggleSheet = () => {
    setIsOpen(!isOpen);
  };

  const toggleModalBottom = () => {
    setModalBottom(!modalBottom);
  }

  const handleMessagesChange = useCallback((messages: any[]) => {
    setChatMessages(messages);
  }, []);

  const handleChatInputFocusChange = useCallback((focused: boolean) => {
    setChatInputFocused(focused);
  }, []);

  const checkIconMic = (toastMess: any) => {
   return toastMess?.includes('active') ? Microphone : MICOFF  
  }

  useEffect(() => {
    // if (!isHost()) {
    //   return;
    // }
    if (streamState === "ended" || streamState === "notStarted") {
      return;
    }
    if (roleCopresenter) {
      setToastMessage("You have joined a live session. You have audio/video capability.");
      setToastImg(null);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 3000);
    }
    if (isHost()){
      setToastMessage(copresenterNames.firstName + " " + copresenterNames.lastName + " has joined the meeting as a co-presenter and has audio and video capability.");
      setToastImg(null);
      setIsShowToast(true);
      setTimeout(() => {
        setToastMessage("");
        setToastImg(null);
        setIsShowToast(false);
      }, 3000);
    }
  }, [copresenterNames]);

  return (
    <>
      <div className="relative w-full h-full">
        <a id="productListingA" style={{opacity:'0'}} href={url}></a>
        <div
          className="h-full w-full flex flex-col"
          id={"idVideoRoomContainer"}
          style={{
            backgroundColor: hasPermission ? 'black' : 'transparent',
            position: isMobile ? 'fixed' : 'relative',
            top: isMobile ? 0 : 'auto',
            left: isMobile ? 0 : 'auto',
            right: isMobile ? 0 : 'auto',
            bottom: isMobile ? 0 : 'auto',
            overflow: 'hidden',
            touchAction: 'none',
            WebkitOverflowScrolling: 'none' as any,
            height: isMobile ? '100vh' : '100%',
            width: '100%',
            zIndex: 0
          }}
          ref={videoRef}
        >
        
          {(isGoliveStatus || !isHost()) && (
            <div
              className="h-full w-full"
              style={{ position: "absolute", zIndex: 0}}
            >
              <VideoRoom />
            </div>
          )}

          {/* Camera Preview in Prep Room */}
          {isHost() && !isGoliveStatus && (
            <div
              className="h-full w-full"
              style={{ position: "absolute", zIndex: 0, paddingBottom: '0px' }}
            >
              <CameraPreview 
                onGoLive={() => {
                  setLoaderMessage(language['creating_stream'] || 'Creating stream...');
                  setIsShowLoader(true);

                  let resp1: any;
                  
                  callCreateStreamAPI()
                    .then((resp: any) => {
                      dispatch(setCreateStreamData(resp));
                      resp1 = resp;
                      callEvent([{
                        "event_data": {
                          "client_id": resp["owner"]['client_id'],
                          "stream_id": resp["stream_id"],
                          "stream_instance_id": resp["stream_instance_id"],
                          "user_id": resp["owner"]['client_id'],
                          "elapsed_seconds": "0",
                          "date": new Date().toUTCString()
                        },
                        "event_type": "stream_started"
                      }]);
                      
                      try {
                        callEvent([{
                          "event_data": {
                            "attendee_email": resp1['metadata']['attendees'][0].email,
                            "attendee_first": resp1['metadata']['attendees'][0].given_name,
                            "attendee_id": resp["attendee_id"],
                            "attendee_role": resp["role"],
                            "attendee_last": resp1['metadata']['attendees'][0].family_name + " (host)",
                            "client_id": resp['owner']['client_id'],
                            "stream_id": resp["stream_id"],
                            "stream_instance_id": resp["stream_instance_id"],
                            "user_id": resp['owner']['user_id'],
                            "max_presenters": 3,
                            "elapsed_seconds": "0",
                            "date": new Date().toUTCString()
                          },
                          "event_type": "camera_started"
                        }]);
                      } catch (error) {
                        console.error(error);
                      }
                      
                      const stream_instance_id = resp["stream_instance_id"];
                      const stream_vendor_user_id = resp["metadata"]["attendees"][0]["stream_vendor_user_id"] ?? 0;
                      
                      callCreateTokenAPI(stream_instance_id, stream_vendor_user_id)
                        .then((tokenResp) => {
                          dispatch(setTokenData(tokenResp));
                          dispatch(setStramState("started"));
                          setIsGoliveStatus(true);
                          setIsShowLoader(false);
                        })
                        .catch((err) => {
                          setIsShowLoader(false);
                          console.error("Error creating token:", err);
                        });
                    })
                    .catch((err) => {
                      setIsShowLoader(false);
                      console.error("Error creating stream:", err);
                    });

                  callGetRTMToken("", true)
                    .then((resp) => {
                      dispatch(setRTMToken(resp));
                    })
                    .catch((err) => {
                      console.error("Error getting RTM token:", err);
                    });
                }}
              />
            </div>
          )}

          <HeaderControls
            handleGoLiveChange={(status: any) => {
              setIsGoliveStatus(status);
            }}
            isHostvalue={isHost()}
            loaderStatus={(flag: any) => {
              setIsShowLoader(flag);
            }}
            loaderMessageTxt={(msg: any) => {
              setLoaderMessage(msg);
            }}
            handleShareClick={(link: any) => {
              setDnLink(link);
              toggleSheet();
            }}
            closeShareSheet={() => {
              setIsOpen(false);
            }}
          ></HeaderControls>

        { slowNetwork &&
           <div 
           className="h-[45px] w-[45px] bg-[#202121]/[0.5] rounded-full flex items-center justify-center"
          style={hasPanel ? {top: '15px', right: '75px', zIndex: 9999, position: 'absolute'} :
            {top: '35px',
            right: '75px',
            zIndex: 9999,
            position: 'absolute',
          }}> 
            <img src={Icon_Wifi_Off} style={{width:'25px', height:'25px'}} />
          </div>
        }

          {/* {isGoliveStatus && !isMobile && (
            <>
              {
                <div className="ml-3 containerParent">
                  <div className={`mt-3 overflow-x-auto containerParent w-full pb-2 pt-2`}>
                    <ProductsListing
                      mobileClick={(urlStr: string) => {
                        setUrl(urlStr);
                        window.open(urlStr, "_blank");
                      
                      }}
                    ></ProductsListing>
                  </div>
                </div>
              }
            </>
          )} */}

          {isRecord && isVisible && (
            <div
              style={{ zIndex: 1 }}
              className="flex w-full items-center justify-center  absolute h-12 bottom-[120px]"
            >
              <div className="flex bg-[#202121]/[0.7] pt-2 pb-2 pr-3 pl-3 rounded">
                <img
                  src={RecordON}
                  alt="camera"
                  height={22}
                  width={22}
                  className="cursor-pointer"
                ></img>
                <div className="text-white ml-3">Recording is ON</div>
              </div>
            </div>
          )}
          {isVisible && !isRecord && (
            <div
              style={{ zIndex: 1 }}
              className=" flex w-full items-center justify-center  absolute h-12 bottom-[120px]"
            >
              <div className="flex bg-[#202121]/[0.7] pt-2 pb-2 pr-3 pl-3 rounded">
                <img
                  src={RecordOFF}
                  alt="camera"
                  height={22}
                  width={22}
                  className="cursor-pointer"
                ></img>
                <div className="text-white ml-3">Recording is OFF</div>
              </div>
            </div>
          )}
          {checkRecord && toggleRecording && (
            <div
              style={{ zIndex: 1 }}
              className=" flex w-full items-center justify-center  absolute bottom-[120px]"
            >
              <div className="flex bg-[#202121]/[0.7] pt-2 pb-2 pr-3 pl-3 rounded">
                <div className="text-white ml-3 items-center justify-center ">
                  You don't have permission to record.
                </div>
              </div>
            </div>
          )}

          {/* Host Disconnection Message for Attendees */}
          {!isHost() && isHostConnected === false && streamState === "started" && (
            <div
              style={{ zIndex: 9998 }}
              className="flex w-full items-center justify-center absolute top-[100px] px-4"
            >
              <div className="flex bg-[#202121]/[0.9] pt-3 pb-3 pr-5 pl-5 rounded-lg max-w-md">
                <div className="text-white text-center text-sm md:text-base">
                  The host is experiencing connectivity issues. Please wait a moment while they reconnect.
                </div>
              </div>
            </div>
          )}

      {!hasPermission && isHost() && <div
          style={{
            position: 'absolute',
            top: '300px',
            width:'100%',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
            <>
              <img src={No_Permission} className="mx-auto mt-10" style={{height: 74}}></img>
              <div style={{width:'269px', textAlign:'center', marginTop:'10px'}}>
                <p style={{color:'#DEDEDE', fontSize:'16px', fontWeight:'400', lineHeight:'28px'}}>Audio and Video permissions are not allowed. Change your browser settings.</p>
              </div>
            </>
        </div>}

        {/* {
             slowNetwork && <div
              style={{
                borderRadius: '6px',
                padding: '10px',
                position: 'absolute',
                backgroundColor: 'rgba(158, 25, 33, 0.8)',
                bottom: '168px',
                left:'5%',
                width:'90%',
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'center',
                alignItems: 'center',
                textAlign: 'start',
              }}
              >
                <>
                  <img src={Alert} className="mx-auto" style={{height: 30}}></img>
                  <div style={{width:'269px', textAlign:'center', marginTop:'10px'}}>
                    <p style={{color:'#DEDEDE', fontSize:'16px', fontWeight:'400', lineHeight:'28px'}}>{language['poor_internet']} <br/> {language['have_av_issues']}</p>
                  </div>
                </>

              </div>
        } */}

          {micSelectorVisible && (
            <div
              ref={camRef}
              style={{ zIndex: 1000, position: 'absolute',  bottom: `calc(${micHeight + 100}px)`, left : 20 }}
            >
              <MicSelector toggleVisible={() => {setMicSelectorVisible(!micSelectorVisible)}}></MicSelector>
            </div>
          )}

          {camSelectorVisible && (
            <div
              ref={camRef}
              style={{ zIndex: 1000, position: 'absolute',  bottom: `calc(${camHeight + 100}px)`, left : 50 }}
            >
              <CamSelector toggleVisible={() => {setCamSelectorVisible(!camSelectorVisible)}}></CamSelector>
            </div>
          )}
        

          {/* StreamControls - Hidden during preview mode, shown when live */}
          {(roleCopresenter || isHost()) && isGoliveStatus && (
            <div
              className="flex w-full items-center justify-left  absolute bottom-[0px]"
              id="streamContainer"
              style={{ zIndex: 99 }}
            >
              <StreamControls
                isGoliveStatus={isGoliveStatus}
                userCheck={userCheck}
                setCamSelectorVisible={() => setCamSelectorVisible(!camSelectorVisible)}
                setMicSelectorVisible={() => setMicSelectorVisible(!micSelectorVisible)}
                alertCameraState={() => {
                  setToastMessage(
                    "Camera will remain OFF during screen sharing."
                  );
                  setToastImg(null);
                  setIsShowToast(true);
                  setTimeout(() => {
                    setToastMessage("");
                    setToastImg(null);
                    setIsShowToast(false);
                  }, 2000);
                  }}
                  alertSomeoneShared={() => {
                    setToastMessage("You cannot share your screen while another presenter is screen sharing.");
                    setToastImg(null);
                    setIsShowToast(true);
                    setTimeout(() => {
                      setToastMessage("");
                      setToastImg(null);
                      setIsShowToast(false);
                    }, 2000);
                    }
                }
                checkIfAnyoneSharing={checkIfAnyoneSharing}
              ></StreamControls>
            </div>
          )}

          {isShowToast && (
            <div
              className="flex w-full items-center justify-center  absolute bottom-[120px] pr-5 pl-5"
              id="toastContainer"
              style={{ zIndex: 9999 }}
            >
              <ToastMessage
                imgSrc={toastImg}
                message={toastMessage}
              ></ToastMessage>
            </div>
          )}

          {/* {(isMobile && !isHost()) && (
            <div
              className="flex absolute bottom-5 right-3 bg-[#202121] pl-2 pr-2 pt-2 pb-2 rounded-full"
              style={{ zIndex: 99 }}
              onClick={() => {
                setModalBottom(true);
              }}
            >
              <img className="h-7" src={Chatnew} />
            </div>
          )} */}

          {/* {(isMobile && !isHost()) && (
            <div
              className="flex absolute bottom-2 left-0 w-full justify-center items-center"
              style={{ zIndex: 99, height: "40px" }}
            >
            <div
              className="flex bg-[#202121] justify-center items-center"
              style={{opacity: 0, width:'calc(100% - 112px)', height:'40px', marginLeft:'8px', border: '1px solid white', borderRadius: '8px'}}
            >
              <textarea
                disabled={false}
                placeholder={"What's on your mind?"}
                style={{ borderRadius: '8px', padding: '10px', overflow:'hidden'}}
                className="resize-none outline-none text-sm text-white bg-[#222324] rounded-br h-full w-full rounded-bl justify-center items-center"
              ></textarea>
            </div>
            <div style={{width:'8px'}}></div>
            <div
              className="flex justify-center items-center bg-[#202121] pl-2 pr-2 pt-2 pb-2"
              style={{ zIndex: 99 , width:'40px', height:'40px', border: '1px solid white', borderRadius:'8px'}}
              onClick={() => {
                setModalBottom(!modalBottom);
              }}
            >
              <img className="h-7" src={Chatnew} />
            </div>
            <div style={{width:'8px'}}></div>
            <div
              className="flex justify-center items-center bg-[#202121] pl-2 pr-2 pt-2 pb-2"
              style={{ zIndex: 99 , width:'40px', height:'40px', border: '1px solid white', borderRadius:'8px'}}
              onClick={() => {
                setInteractionsBottom(true);
              }}
            >
              <img src={List} />
            </div>

            <div style={{width:'9px'}}></div>
           
            </div>
          )} */}

        {(toastMess && !isHost()) && (
            <div
            className="flex w-full items-center justify-center  absolute bottom-[160px]"
            style={{ zIndex: 99 }}
          >
              <ToastMessage
                imgSrc={checkIconMic(toastMess)}
                message={toastMess}
              ></ToastMessage>
            </div>
          )}

          {isMobile && (
              <ModalBottomChatMobile
              setModalBottom={toggleModalBottom}
               setInteractionsBottom={setInteractionsBottom}
                modalIsOpen={modalBottom}
                onMessagesChange={handleMessagesChange}
                onChatInputFocusChange={handleChatInputFocusChange}
              />
          )}

          {isMobile && (
            <div style={ interactionsBottom ? { zIndex: -1 } : { zIndex: 99999 }}>
              <ModalBottomInteractionsMobile
                modalIsOpen={interactionsBottom}
                onClose={() => {
                  setInteractionsBottom(false);
                }}
              />
            </div>
          )}

          {showBottomSheet && (
            <div style={{ zIndex: 99999 }}>
              <BottomSheet
                url={url}
                onClose={() => {
                  setShowBottomSheet(false);
                }}
              />
            </div>
          )}

          <div
            className={`absolute w-full  ${
              isOpen ? "pointer-events-auto" : "pointer-events-none"
            } overflow-y-auto containerbottomSheet`}
            style={{ zIndex: 9999, bottom: '120px', height: 'auto', maxHeight: '320px' }}
          >
            <CustomShareBottomSheet
              isOpen={isOpen}
              toggleSheet={toggleSheet}
              linkUrl={dnLink}
            />
          </div>

          {isGoliveStatus && isMobile && modalBottom && !(isIOS && chatInputFocused) && (
            <div 
              className="w-full fixed chatMessagesContainer"
              style={{ 
                zIndex: 98, 
                bottom: '180px',
                maxHeight: 'calc(100vh - 240px)',
                overflow: 'hidden',
                pointerEvents: 'auto',
                touchAction: 'pan-y',
              }}
            >
              <div className="px-2 py-2 bg-black bg-opacity-70 rounded-t-lg h-full overflow-y-auto" style={{ WebkitOverflowScrolling: 'touch' }}>
                <MessageItem 
                  messages={chatMessages?.length >= 5 ? [...chatMessages] : chatMessages?.length >= 0 ? chatMessages : []} 
                />
              </div>
            </div>
          )}

          {isGoliveStatus && isMobile && (
            <div 
              className="w-full fixed bottom-[60px]"
              style={{ zIndex: 99 }}
            >
              <div className="px-2 py-3 bg-black bg-opacity-70">
                <div className="overflow-x-auto w-full">
                  <ProductsListing
                    mobileClick={(urlStr: string) => {
                      setUrl(urlStr);
                      window.open(urlStr, "_blank");
                    }}
                  ></ProductsListing>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      <Loader
        isShowLoader={isShowLoader}
        // message={"Creating stream please wait..."}
        message={loaderMessage}
      ></Loader>
    </>
  );
};

export default HostAttendeeView;
